import React, { useEffect, useRef, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import { fetchBuildId, isNewVersion, VERSION_CHECK_INTERVAL } from '../lib/versionCheck';

// Avviso non bloccante di nuova versione. Nessun ricaricamento automatico.
export const UpdateBanner = () => {
  const [available, setAvailable] = useState(false);
  const current = useRef(null);

  useEffect(() => {
    let active = true;
    const check = async () => {
      const id = await fetchBuildId();
      if (!active || !id) return;
      if (!current.current) {
        current.current = id;
        return;
      }
      if (isNewVersion(current.current, id)) setAvailable(true);
    };
    check();
    const onFocus = () => check();
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisible);
    const timer = setInterval(check, VERSION_CHECK_INTERVAL);
    return () => {
      active = false;
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisible);
      clearInterval(timer);
    };
  }, []);

  if (!available) return null;

  const reload = async () => {
    if ('serviceWorker' in navigator) {
      try {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.update()));
      } catch (e) { /* ignora */ }
    }
    window.location.reload();
  };

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[120] w-[calc(100%-32px)] max-w-md px-4 py-3 rounded-xl bg-[#0a0e0d]/95 border border-usdt/40 shadow-[0_0_30px_rgba(38,161,123,.25),0_14px_30px_rgba(0,0,0,.6)] flex items-center gap-3"
      data-testid="update-banner"
    >
      <RefreshCw size={18} className="text-usdt flex-shrink-0" />
      <p className="text-sm text-white flex-1">Nuova versione dell'app disponibile, aggiorna ora</p>
      <Button
        onClick={reload}
        size="sm"
        className="bg-usdt hover:bg-usdt/90 text-usdt-ink font-semibold flex-shrink-0"
        data-testid="update-banner-reload-btn"
      >
        Aggiorna
      </Button>
    </div>
  );
};

export default UpdateBanner;
